module.exports = __webpack_public_path__ + "img/teacher3_yijian.a3b67b17.png";